import { Check } from 'lucide-react';

interface ProgressIndicatorProps {
  currentStep: number;
}

export function ProgressIndicator({ currentStep }: ProgressIndicatorProps) {
  const steps = [
    { number: 1, title: 'اطلاعات دانش‌آموز و والدین' },
    { number: 2, title: 'تاریخ و زمان مصاحبه' },
    { number: 3, title: 'تایید نهایی' },
  ];

  return (
    <div className="w-full">
      <div className="flex items-center justify-between relative">
        {/* Progress Line */}
        <div className="absolute top-6 left-0 right-0 h-0.5 bg-gray-200 -z-10">
          <div
            className="h-full transition-all duration-500 ease-in-out"
            style={{
              width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
              backgroundColor: 'var(--primary-gold)',
            }}
          />
        </div>

        {/* Step Circles */}
        {steps.map((step) => {
          const isCompleted = currentStep > step.number;
          const isCurrent = currentStep === step.number;

          return (
            <div key={step.number} className="flex flex-col items-center flex-1">
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
                  isCompleted
                    ? 'shadow-md'
                    : isCurrent
                    ? 'shadow-lg ring-4 ring-opacity-30'
                    : 'bg-white border-2'
                }`}
                style={{
                  backgroundColor: isCompleted || isCurrent ? 'var(--primary-gold)' : 'white',
                  borderColor: isCompleted || isCurrent ? 'var(--primary-gold)' : 'var(--border-light)',
                  color: isCompleted || isCurrent ? 'var(--secondary-green)' : 'var(--text-gray)',
                }}
              >
                {isCompleted ? (
                  <Check className="w-6 h-6" />
                ) : (
                  <span className="text-lg">{step.number}</span>
                )}
              </div>
              <p
                className={`mt-3 text-sm text-center max-w-[120px] ${
                  isCurrent ? '' : ''
                }`}
                style={{
                  color: isCurrent ? 'var(--secondary-green)' : 'var(--text-gray)',
                  fontWeight: isCurrent ? '600' : '400',
                }}
              >
                {step.title}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}